<div *ngIf="isLoading | async" aria-busy="true" aria-live="polite" class="loader-container" aria-label="Carregando..."
  aria-hidden="false">
  <div class="loader-content">
    <div class="loader-item"></div>
    <div class="loader-item"></div>
    <div class="loader-item"></div>
  </div>
  <span class="loading" >Carregando conteúdo</span>
</div>
